module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Eva Schloss\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v(" "), _c('B', [_vm._v("Eva Schloss")]), _vm._v(" is a Holocaust survivor, peace activist, international speaker, teacher and a humanitarian. Her other titles include "), _c('I', [_vm._v("After Auschwitz")]), _vm._v(" (Hodder & Stoughton) and "), _c('I', [_vm._v("The Promise")]), _vm._v(" (Penguin UK). Eva continues to conduct lectures about the Holocaust and its consequences. She lives in London.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/s2r9uP/tc-custom/9781467457668.jpg?1730410022199",
      "alt": "This image is the cover for the book Eva's Story"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Eva's Story\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("People around the world know the tragic story of Anne Frank, the teenage girl who lost her life in a concentration camp during the Holocaust. But most people don't know about Eva Schloss, Anne’s playmate and posthumous stepsister. Though Eva, like Anne, was imprisoned in Auschwitz at the age of 15, her story did not end there. Together with her mother, Eva endured daily degradation and countless miseries at the hands of the Nazis. She was freed in 1945, but it would be decades before Eva was able to share her survivor’s tale with the world.")]), _c('p', [_vm._v("Concluding with new discussion questions and a revealing interview with Eva, this moving memoir recounts—without bitterness or hatred—the horrors of war, the love between mother and daughter, and the strength and determination that helped a family overcome danger and tragedy.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing Co.\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0